export const UPLOAD_SHEET_CONSTANTS = {
    cardTitle: 'For employees still working for your company, upload spreadsheet with correct passport number, date of birth and nationality',
    cardDesc: [
        'Download the list of employees with invalid details from the portal.',
        'Recheck the passport number, date of birth and nationality for employees on the list who are still working with your company.',
        'Upload corrected passport number, date of birth and nationality if any of them are incorrect.',
        'If data is correct, no further action is required and you can ignore this message on the portal. Cards will not be blocked.'
    ]
}